// ======================================================================
// File: src/modules/ipe/routes/IPERoutes.js
// ======================================================================

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import IPELayout from "../IPELayout";
import RawMaterialListPage from "../../ppe/pages/material/raw-material/RawMaterialListPage";
import BusinessPartnerListPage from "../../ppe/pages/masters/business_partner/BusinessPartnerListPage";

// ================= PROCUREMENT (FROM PPE) =================
import IndentListPage from "../../ppe/pages/procurement/indent/list/IndentListPage";
import IndentDetailPage from "../../ppe/pages/procurement/indent/view/IndentDetailPage";

import RFQList from "../../ppe/pages/procurement/rfq/view/RFQList";
import RFQCompare from "../../ppe/pages/procurement/rfq/view/RFQCompare";

import POList from "../../ppe/pages/procurement/purchaseOrder/POList";

import GRNListPage from "../../ppe/pages/procurement/grn/list/GRNListPage";
import GRNDetail from "../../ppe/pages/procurement/grn/view/GRNDetail";

// -------------------- ENQUIRY --------------------
import EnquiriesListPage from "../enquiry/pages/EnquiriesListPage";
import CreateEnquiryPage from "../enquiry/pages/CreateEnquiryPage";
import EnquiryDetailPage from "../enquiry/pages/EnquiryDetailPage";

// -------------------- BOM MASTER --------------------
import BOMMasterList from "../engineering/bom/BOMMasterList";
import BOMCreateOverlay from "../engineering/bom/BOMCreateOverlay";

import CostingViewPage from "../costing/pages/CostingViewPage";

import IPEOrderListPage from "../order/pages/IPEOrderListPage";

import ProjectDetailPage from "../../pms/pages/ProjectDetailPage";
import ProjectList from "../../pms/pages/ProjectList";

import UserBPMappingPage from "../../pms/pages/UserBPMappingPage";
import TaskTemplatePage from "../../pms/task_template/pages/TaskTemplatePage";

import MaterialReservationPage  from "../../pms/task_material/pages/MaterialReservationPage";

import PackingDispatchDetailPage
from "../../pms/material_logistics/pages/PackingDispatchDetailPage";

import ReceiptWorkbenchPage
from "../../pms/material_logistics/pages/ReceiptWorkbenchPage";

import ReconciliationWorkbenchPage
from "../../pms/material_logistics/pages/ReconciliationWorkbenchPage";


import ReceiptWorkbenchListPage
from "../../pms/material_logistics/pages/ReceiptWorkbenchListPage";

import ReconciliationWorkbenchListPage
from "../../pms/material_logistics/pages/ReconciliationWorkbenchListPage";

import MaterialTraceabilityReportPage
from "../../pms/material_logistics/pages/MaterialTraceabilityReportPage";

import TaskExecutionWorkbenchPage
from "../../pms/task_execution/pages/TaskExecutionWorkbenchPage";

import SiteStoreDashboardPage
from "../../pms/pages/SiteStoreDashboardPage";

import EquipmentMasterPage
from "../../ppe/pages/engineering/equipment/EquipmentMasterPage";
import ProductFamilyListPage
from "../../ppe/pages/engineering/product-family/ProductFamilyListPage";

import ProductVariantListPage
from "../../ppe/pages/engineering/product-variant/ProductVariantListPage";


// ======================================================================
// DASHBOARD
// ======================================================================

import IPEDashboard from "../dashboard/IPEDashboard";


// =============================================================================
// PMS → MATERIAL LOGISTICS
// =============================================================================

import PackingDispatchWorkbenchPage from "../../pms/material_logistics/pages/PackingDispatchWorkbenchPage";

export default function IPERoutes() {
  return (
    <IPELayout>
      <Routes>

        {/* Default */}
        {/*<Route path="/" element={<Navigate to="dashboard" replace />} /> */}
        <Route
            index
            element={
              <Navigate
                to="dashboard"
                replace
              />
            }
          />

        {/* =====================================================
           ENQUIRY MODULE
        ===================================================== */}

        <Route
          path="enquiries"
          element={<EnquiriesListPage />}
        />

        <Route
          path="enquiries/create"
          element={<CreateEnquiryPage />}
        />

        <Route
          path="enquiries/:enquiryId"
          element={<EnquiryDetailPage />}
        />

        <Route path="orders" element={<IPEOrderListPage />} />
        
        <Route
          path="pms/project/:projectId"
          element={<ProjectDetailPage />}
        />
        
        <Route path="pms/projects" element={<ProjectList />} />

        <Route
          path="pms/user-bp-mapping"
          element={<UserBPMappingPage />}
        />

        <Route
          path="pms/task-templates"
          element={<TaskTemplatePage />}
        />
        <Route
          path="pms/material-reservation"
          element={<MaterialReservationPage />}
        />

        <Route
          path="pms/packing-dispatch"
          element={<PackingDispatchWorkbenchPage />}
        />

        <Route
          path="pms/packing-dispatch/:dispatchId"
          element={<PackingDispatchDetailPage />}
        />
        {/* =============================================================== */}
{/* RECEIPT WORKBENCH */}
{/* =============================================================== */}

<Route
  path="pms/material-receipt"
  element={<ReceiptWorkbenchListPage />}
/>

<Route
  path="pms/material-receipt/:receiptId"
  element={<ReceiptWorkbenchPage />}
/>


{/* =============================================================== */}
{/* RECONCILIATION WORKBENCH */}
{/* =============================================================== */}

<Route
  path="pms/material-reconciliation"
  element={<ReconciliationWorkbenchListPage />}
/>

<Route
  path="pms/material-reconciliation/:receiptId"
  element={<ReconciliationWorkbenchPage />}
/>

<Route
  path="pms/material-traceability"
  element={<MaterialTraceabilityReportPage />}
/>

<Route
  path="pms/task-execution"
  element={<TaskExecutionWorkbenchPage />}
/>
<Route
  path="pms/site-store-dashboard"
  element={<SiteStoreDashboardPage />}
/>

        {/* =====================================================
           ENGINEERING
        ===================================================== */}

        <Route
            path="engineering/masters/product-family"
            element={<ProductFamilyListPage />}
          />

          <Route
            path="engineering/masters/product-variants"
            element={<ProductVariantListPage />}
          />
        
        <Route
          path="engineering/bom"
          element={<BOMMasterList />}
        />
        <Route
            path="engineering/equipment"
            element={<EquipmentMasterPage />}
          />
        <Route
          path="engineering/bom/create"
          element={<BOMCreateOverlay />}
        />

        <Route
          path="engineering/bom/edit/:bomId"
          element={<BOMCreateOverlay />}
        />

        <Route
          path="engineering/bom/view/:bomId"
          element={<BOMCreateOverlay />}
        />
        
        {/* ================= MATERIAL (REUSED FROM PPE) ================= */}
        <Route
          path="material/masters/raw-material"
          element={<RawMaterialListPage />}
        />

        {/* ================= MASTERS (REUSED FROM PPE) ================= */}
        <Route
          path="masters/business-partner"
          element={<BusinessPartnerListPage />}
        />
        
        /* ================= PROCUREMENT (REUSED FROM PPE) ================= */

        // -------- INDENT --------
        <Route
          path="procurement/indent"
          element={<IndentListPage />}
        />

        <Route
          path="procurement/indent/:id"
          element={<IndentDetailPage />}
        />

        // -------- RFQ --------
        <Route
          path="procurement/rfq"
          element={<RFQList />}
        />

        <Route
          path="procurement/rfq/compare/:rfqId"
          element={<RFQCompare />}
        />

        // -------- PURCHASE ORDER --------
        <Route
          path="procurement/purchase-order"
          element={<POList />}
        />

        // -------- GRN --------
        <Route
          path="procurement/grn"
          element={<GRNListPage />}
        />

        <Route
          path="procurement/grn/:id"
          element={<GRNDetail />}
        />
        
        {/* -------------------- COSTING --------------------*/}

        <Route
          path="enquiries/:enquiryId/cost-sheet"
          element={<CostingViewPage />}
        />
        <Route
        path="dashboard/*"
        element={<IPEDashboard />}
      />

      </Routes>

      
    </IPELayout>
  );
}